import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useApi } from 'api/api-context';
import BookingLayout from 'pages/booking/BookingLayout';
import { BOOKING_ACCOUNT_CREDIT_PURCHASE_DETAIL_PATH } from 'routes/paths';
import useLang from 'lang';

/** Reconciles a Stripe bundle checkout return with the provider. */
export default function CreditPurchaseReturn() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { getAction } = useApi();
  const { _t } = useLang();
  const [error, setError] = useState(false);

  useEffect(() => {
    const purchaseId = Number(searchParams.get('purchase_id'));
    window.history.replaceState({}, document.title, window.location.pathname);
    if (!purchaseId) {
      setError(true);
      return;
    }
    getAction('RefreshReservationCreditPurchase')({ parameters: { purchaseId } })
      .then((response: any) => {
        navigate(BOOKING_ACCOUNT_CREDIT_PURCHASE_DETAIL_PATH.insert({ purchaseId: String(purchaseId) }), {
          replace: true,
          state: { purchase: response.purchase },
        });
      })
      .catch(() => setError(true));
  }, [getAction, navigate, searchParams]);

  return (
    <BookingLayout>
      <main className="credit-purchase-page">
        <h1>{error ? _t('Payment status unavailable') : _t('Verifying payment...')}</h1>
        {error && <p>{_t('Open My credit purchases to refresh the payment status.')}</p>}
      </main>
    </BookingLayout>
  );
}
